import { render, staticRenderFns } from "./l-admin.vue?vue&type=template&id=15f0a25f&lang=pug&"
import script from "./l-admin.vue?vue&type=script&lang=js&"
export * from "./l-admin.vue?vue&type=script&lang=js&"
import style0 from "./l-admin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f0a25f')) {
      api.createRecord('15f0a25f', component.options)
    } else {
      api.reload('15f0a25f', component.options)
    }
    module.hot.accept("./l-admin.vue?vue&type=template&id=15f0a25f&lang=pug&", function () {
      api.rerender('15f0a25f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/l-admin.vue"
export default component.exports